// Opening the Activity feed reads it. These decide WHEN the page may call
// POST notifications/read on the viewer's behalf: on an open that shows unread
// alerts, and again only when an alert the viewer has not seen in this open
// arrives while the tab is visible. Never on a plain poll tick (every id is
// already observed), never while hidden, never while a call is in flight.
//
// "Observed" is by id, not by read state, so a row the user deliberately
// toggles back to unread does not re-arm the call on the next tick.

const isUnread = (a) => a && !(a.read === true || a.read === 1 || a.read === '1');

export const newUnreadIds = (alerts, seen) =>
    (alerts || []).filter((a) => isUnread(a) && !seen.has(a.id)).map((a) => a.id);

export const shouldAutoMarkRead = ({alerts, seen, visible, inFlight}) =>
    visible === true && !inFlight && newUnreadIds(alerts, seen).length > 0;

// Record every loaded id (read or not) as seen for this open. Returns the same
// Set so callers can chain it.
export const observe = (alerts, seen) => {
    (alerts || []).forEach((a) => { if (a && a.id != null) seen.add(a.id); });
    return seen;
};
